import styled from 'styled-components';
import {OcrBatchPrimaryButton} from "../../../pages/ocr-batch/OcrBatch.styled";
import {tokens} from "../../../theme";
import {Button} from "@mui/material";

export const ExportDropdownWrapper = styled.div`
    position: relative;
`;

export const ExportDropdownTriggerButton = styled(OcrBatchPrimaryButton)``;

export const ExportDropdownChevron = styled.span<{ $open: boolean }>`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: ${({ $open }) => $open
    ? 'rotate(-135deg) translateX(-2px)'
    : 'rotate(45deg) translateY(-2px)'};
    transition: transform 0.2s;
    margin-right: 4px;
`;

export const ExportDropdownPanel = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 240px;
    background: ${({ theme }) => theme.palette.background.paper};
    border: 1px solid  ${({ theme }) => theme.palette.divider};
    border-radius: ${tokens.radius.md};
    padding: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10), 0 2px 6px rgba(0,0,0,0.04);
    z-index: 50;
`;

export const ExportDropdownMeta = styled.p`
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.semibold};;

    color: ${({ theme }) => theme.palette.text.hint};
    padding: 2px 6px 6px;
    margin: 0;
`;

interface ExportItemProps {
    $disabled?: boolean;
}

export const ExportFormatCheckbox = styled.div<ExportItemProps>`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 8px;

    color: ${({ $disabled, theme }) => $disabled ? theme.palette.text.disabled : theme.palette.text.primary};
    cursor: ${({ $disabled }) => $disabled ? 'default' : 'pointer'};
    pointer-events: ${({ $disabled }) => $disabled ? 'none' : 'auto'};

    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        accent-color: ${({ theme }) => theme.palette.text.primary};
    }
`;

export const ExportFormatConfirmButton = styled(Button)`
    width: 100%;
    margin-top: 4px;
`;